// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"_9zcpo","body":"QTEBn","body-art":"AhMxD","rc-tabs-bar":"ctJA-","rc-tabs-tab":"_8B4tP","rc-tabs-tab-active":"hYaW5","container":"gLBQ8"};